<template>
    <div id="recharge">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">充值中心</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>

        <div class="userinfo">
            <el-image :src="getUserInfo.cover">
                <div slot="error" class="image-slot">
                    <img src="./../assets/images/user.png" alt="">
                </div>
            </el-image>
            <div class="info">
                <p class="name">{{getUserInfo.username}} <span>用户编号 ({{getUserInfo.id}})</span></p>
                <p>余额：<span>{{getUserInfo.money}}</span>书币 <span>{{getUserInfo.voucher}}</span>书豆</p>
            </div>

        </div>

        <div class="rechargetype">
            <h3>充值方式</h3>
            <ul>
                <li class="active" v-if="isWechat">
                    <img src="./../assets/images/wechat.png" alt="">
                    微信
                    <span><i class="el-icon-check"></i></span>
                </li>
                <li class="active" v-if="!isWechat">
                    <img src="./../assets/images/ali.png" alt="">
                    支付宝
                    <span><i class="el-icon-check"></i></span>
                </li>
            </ul>
        </div>

        <div class="priceType">
            <h3>充值金额</h3>
            <ul>
                <li :class="{active:active == val.id}" v-for="val in list" @click="active = val.id;">
                    <div v-if="val.id != 1">
                        <h5 v-if="val.money == 999">¥ {{val.money / 100}}元</h5>
                        <h5 v-if="val.money !== 999">¥ {{val.money / 100}}.00元</h5>
                        <p v-if="val.voucher > 0">({{val.money}}书币 + {{val.voucher}}书豆，共得{{val.money+val.voucher}})</p>
                        <p v-else>共得{{val.money}}书币</p>
                        <!--<p class="song" v-show="val.voucher > 0">加送{{val.voucher}}书豆</p>-->
                        <span><i class="el-icon-check"></i></span>

                    </div>
                </li>


                <!--<li class="other" :class="{active:active == 0}" @click="active = 0">-->
                    <!--<div>-->
                        <!--<p>其他金额 <input type="number" v-model.number="money"> 元</p>-->

                        <!--<span><i class="el-icon-check"></i></span>-->

                    <!--</div>-->
                <!--</li>-->

            </ul>

            <h3 v-if="yearList.length ">年卡办理</h3>
            <ul v-if="yearList.length " class="yearul">
                <template v-for="item in yearList">
                    <li :class="{active:active == item.id}" class="year" @click="active = item.id;">
                        <div>
                            <h5>¥ {{item.money / 100}}元</h5>
                            <!--<p>尊贵会员</p>-->
                            <p v-if="item.description">{{item.description}}</p>
                            <p v-else>尊贵会员</p>
                            <p class="song">万本书籍无限畅读！</p>
                            <span><i class="el-icon-check"></i></span>

                        </div>

                    </li>
                </template>


            </ul>

            <p class="btn"><button @click="doRecharge">立即充值</button></p>
        </div>

        <div class="tishi">
            <h3>温馨提示</h3>

            <p>1、用户同意并理解，充值"书币"虚拟币，一经购买不适用无理由退款，充值一旦成功，充值即确定完成，将不能提供任何更改，修正服务，用户不得以消费完成后账户内仍有剩余书币为由要求退款！</p>
            <p>2、1元=100书币，充值书币可能会有延迟，充值后如一小时仍未到账，请及时联系客服处理，客服微信号：glg318  。</p>
            <p>3、客服工作时间：8:00-24:00</p>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Recharge",
        computed:{
            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
            isWechat(){
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    return true;
                }
                return false;
            }
        },
        data(){
            return {
                list : [],
                yearList : [],
                active : 2,
                money : 0,

            }
        },
        methods: {
            resetUserInfo(){
                this.axios.post('/api/user/getUserInfo').then(r => {
                    let data = r.data;
                    if(data.code == 1){
                        this.$store.dispatch('setUserInfo',data.data);
                    }
                })
            },
            getRecharge() {
                this.axios.post('/api/recharge/getRechargeType').then(r => {
                    let data = r.data;
                    if(data.code){
                        this.list = data.data.list;
                        this.active = this.list[0].id;
                        this.yearList = data.data.yearList
                    }
                })
            },
            doRecharge(){
                if(this.active == 0 && this.money < 20){
                    alert("最低充值金额20元");
                    return;
                }

                const loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                    spinner: 'el-icon-loading',
                });
                this.axios.post('/api/recharge/doRecharge',{
                    active : this.active,
                    money : this.money,
                }).then(r => {
                    loading.close();
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        if(data.data.type == 1){
                            location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                        }else{
                            location.href= process.env.VUE_APP_WECHAR + '/recharge/doRecharge/?orders=' + data.data.orders;
                        }
                    }
                })

            }
        },
        created() {
            this.resetUserInfo();
            this.getRecharge();
        }
    }
</script>

<style lang="less">
    #recharge{background: #f6f6f7;padding-bottom: 100px;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .userinfo{padding: 20px;overflow: auto;background:#fff;
            .el-image{float: left;
                width:128px;height:128px;border-radius: 50%;overflow: hidden;
                img{width: 100%;height:100%;}
            }
            .info{float: left;padding: 20px;
                p{font-size: 26px;color:#333;line-height: 50px;
                    span{color: @theme;}
                }
                .name{font-size: 30px;color:#333;
                    span{font-size: 24px;color: #6e6e6e;}
                }
            }
        }

        .rechargetype{padding: 20px;margin-top: 20px;background: #fff;
            h3{border-left: 4px solid @theme;text-indent: 20px;font-size: 30px;}
            ul{
                padding:40px 0;
                li{width:220px;border:1px solid #efefef;line-height: 80px;padding-left: 20px;overflow: hidden;font-size: 30px;border-radius: 10px;
                    img{width:44px;height:44px;vertical-align:middle}
                    span{display: none;}
                }
                li.active{border-color:@theme;position: relative;
                    span{display: block;position:absolute;top: -40px;right:-40px;background: @theme;width:80px;height:80px;text-align: center;line-height: 128px;    transform: rotate(45deg);
                        i{color: #fff;transform: rotate(-45deg)}
                    }
                }
            }
        }

        .priceType{padding:20px 0;background: #fff;margin-top: 20px; overflow: auto;
            h3{border-left: 4px solid @theme;text-indent: 20px;font-size: 30px;margin-left: 20px;}
            ul{padding: 40px 0;display: flex;flex-wrap: wrap;
                li{flex-basis: 50%;padding: 20px;
                    div{border: 1px solid #efefef;height:100%;position:relative;overflow: hidden;border-radius: 20px;padding: 20px;text-align: center;
                        h5{font-size: 32px;font-weight: 400;border-bottom: 1px solid #efefef;line-height: 60px;}
                        p{font-size: 24px; color:@theme;line-height: 40px;}
                        .song{font-weight: 500;}
                        span{display: none;position:absolute;top: -40px;right:-40px;background: @theme;width:80px;height:80px;text-align: center;line-height: 128px;    transform: rotate(45deg);
                            i{color: #fff;transform: rotate(-45deg)}
                        }
                    }

                }
                li.active{
                    div{border:1px solid @theme;}
                    span{display: block;}
                }
                .other{height: 222px;
                    div{
                        height:100%;
                        p{line-height: 150px;}
                        input{width:100px;border:none;border-bottom: 1px solid #efefef;}
                    }

                }

            }

            .yearul{display: block;}

            .btn{padding: 0 20px;position: fixed;bottom: 0;width: 100%;
                button{width:100%;background: @theme;color:#fff;height: 80px;border-radius: 10px;border:none;font-size: 30px;}
            }

        }

        .tishi{padding: 20px;margin-top: 20px;background: #fff;
            h3{border-left: 4px solid @theme;text-indent: 20px;font-size: 30px;margin-bottom: 20px;}

            p{color: #a9a9a9;font-size: 28px;}


        }
    }

</style>
